<template>
  <Activity title=""
            :vertical="!online ? 'center' : 'top'"
            :back="{ name: 'MainActivity' }"
            class="delivery-list">
    <offline-indicator v-if="!online"/>

    <div v-else>
      <font-awesome-icon icon="spinner" size="3x" spin v-if="loading"/>

      <div v-else>
        <h2 class="float-left">{{ t(`app.main.button.deliveries.${context.toLowerCase()}`) }}</h2>

        <router-link :to="{ name: 'DeliveryReportActivity', params: { context } }" class="btn btn-primary float-right">
          <font-awesome-icon icon="plus"/>
          Erstellen
        </router-link>

        <br style="clear: both">

        <b-tabs>
          <b-tab title="Offen">
            <ul class="delivery-list mt-2">
              <li v-for="delivery of deliveries" :key="delivery.id">
                <router-link :to="{ name: 'DeliveryActivity', params: { context, id: delivery.id }}">
              <span class="inner">
                <span class="title">
                  <div>
                    <b-badge variant="primary">Käufer</b-badge>&nbsp;
                    {{ delivery.buyerFactoryId }}
                  </div>
                  <div>
                    <b-badge variant="primary">Verkäufer</b-badge>&nbsp;
                    {{ delivery.sellerFactoryId }}
                  </div>
                </span>
                <span class="icon">
                  <font-awesome-icon icon="chevron-right"/>
                </span>
              </span>
                </router-link>
              </li>
            </ul>
          </b-tab>
          <b-tab title="Abgeschlossen">
            <h4>Coming soon...</h4>
          </b-tab>
        </b-tabs>
        <b-button variant="default" @click="reload" :disabled="loading || !online">
          <font-awesome-icon icon="spinner" :spin="loading"/>
          Neu laden
        </b-button>
      </div>
    </div>
  </Activity>
</template>

<script>
import Activity from "@/app/components/Activity.vue";
import {ref, computed, onMounted} from "@vue/composition-api";
import OfflineIndicator from "@/app/components/OfflineIndicator.vue";
import MainActivity from "@/app/activity/MainActivity.vue";
import DeliveryNoteApi from '@/api/delivery-note/delivery-note.js'

export default {
  computed: {
    MainActivity() {
      return MainActivity
    }
  },
  components: {OfflineIndicator, Activity},

  setup() {
    const store = window.useStore()
    const {t} = window.useI18n()
    const {currentRoute} = window.useRouter()

    const context = ref(currentRoute.params.context)

    const producersLoaded = computed(() => store.state.pwa.pigSty.lastFetched !== null)

    const deliveries = ref([])

    const deliveriesLoading = ref(true)
    const online = computed(() => store.state.pwa.online)
    const loading = computed(() => deliveriesLoading.value || !producersLoaded.value)

    const load = async () => {
      deliveriesLoading.value = true
      try {
        const res = await DeliveryNoteApi.getAll(context.value)
        deliveries.value = res.data
      } catch (e) {
        console.error(e)
      }
      deliveriesLoading.value = false
    }

    const getProducerName = id => {
      const res = store.state.pwa.pigSty.data.filter(p => p.id === id)
      if (res.length) {
        return res[0].fullName
      }
    }

    const reload = () => load()

    onMounted(load)

    return {
      t,
      context,
      online,
      loading,
      deliveries,
      reload,
      getProducerName,
    }
  }
}
</script>

<style lang="scss">
ul.delivery-list {
  list-style-type: none;
  margin: 0;
  padding: 0;

  li a {
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #000;
    padding: 18px;
    background: #fff;
    margin-bottom: 6px;
    box-shadow: 0 0 7px #b3b3b3;
    transition: all .3s;

    svg {
      transition: all .3s;
    }

    &, &:hover {
      text-decoration: none;
    }

    &:hover {
      transform: translateX(10px);
      background: #f5f5f5;
    }

    .inner {
      display: flex;
      justify-content: space-between;
    }

    span.icon {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-left: 20px;
    }
  }

  @media screen and (max-width: 991px) {
    .producer {
      display: block;
    }
  }
  @media screen and (min-width: 992px) {
    .date:after {
      display: inline-block;
      content: '-';
      padding: 0 8px;
    }
  }
}
</style>
